<template>
  <div class="teacher_detail">
    <headerBlack-view></headerBlack-view>
    <div class="navigate flex-align">
      <span @click="gohome">首页</span>
      <div>/</div>
      <span @click="golist">名师风采</span>
      <div>/</div>
      <span>名师详情</span>
    </div>
    <div class="detail_wrap flex-align-center">
        <div class="tea_photo">
          <img :src="detail.image" alt="">
        </div>
        <div class="tea_detail ">
            <div class="tea_content">
                <div class="tea_name">
                    <span>{{detail.name}}</span>
                    <span>{{detail.title}}</span>
                </div>
                <div class="tea_project flex-align-around">{{detail.ascriptionName || '无'}}</div>
                <div class="tea_introduce">
                    {{detail.instruction}}
                </div>
            </div>
        </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data(){
    return{
      detail:''
    }
  },
  methods:{
    async getTeaDetail(){
      let param = {
        id:this.$route.params.id,
        type:1
      }
      let resData = await Api.Teacher.getteadetail(param)
      console.log(resData)
      this.detail = resData.data
    },
    gohome(){
      sessionStorage.setItem('active',0)
      this.$router.replace("/home", this)
    },
    golist(){
      this.$router.replace("/teacher_list", this)
    }
  },
  mounted(){
    this.getTeaDetail()
  }
};
</script>

<style lang="less">
@import "./teacher_detail.less";
</style>